module.exports = __webpack_public_path__ + "static/img/12introduceBak.bdcab419.jpg";